import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {

    @Input() message: string = "";

    constructor() {
    }


    ngOnInit() {

    }


    public show(nim?) {
        if (!nim) {
            nim = 3000;
        }

        var x = document.getElementById("snackbar");
        x.className = "show";
        setTimeout(function () {
            x.className = x.className.replace("show", '');
        }, nim);
    }

}
